export default function(msg) {
    // eslint-disable-next-line no-console
    console.log(`%c Error: ${msg}`, 'color:red');
}
